import styled from 'styled-components';
import { MediaQuery } from 'utils/mediaQueries';

export const MinimumOrderContainer = styled.div`
  ${MediaQuery.mobileOnly} {
    display: none;
  }
`;
